class Quotation {
    numberOfBricks;
    numberOfBricksForTheNextVolumeDiscount;
    crowdfundingProperty;
    perBrick;
    crowdfundingDiscount;
    volumeDiscount;
    total;
    constructor(data) {
        this.numberOfBricks = data.numberOfBricks;
        // eslint-disable-next-line max-len
        this.numberOfBricksForTheNextVolumeDiscount = data.numberOfBricksForTheNextVolumeDiscount ?? undefined;
        this.crowdfundingProperty = data.crowdfundingProperty;
        this.perBrick = data.perBrick;
        this.crowdfundingDiscount = data.crowdfundingDiscount ?? undefined;
        this.volumeDiscount = data.volumeDiscount ?? undefined;
        this.total = data.total;
    }
}
export default Quotation;
